import React from 'react'
import PropTypes from 'prop-types'
import Layout from '@layouts/Layout'
import { useIntl } from 'gatsby-plugin-intl'
import { Section1 } from '@templates/terms-of-use'
import Jumbotron from '@components/jumbotron/Jumbotron'
import { faRulerVertical } from '@fortawesome/free-solid-svg-icons'

const TermsOfUse = props => {
  const { formatMessage } = useIntl()
  const { pageContext } = props
  const { languageName } = pageContext

  return <Layout languageName={languageName} pageContext={pageContext}>
    <Jumbotron
      icon={faRulerVertical}
      title={formatMessage({ id: 'terms-of-use' })}
      description=''
    />
    <div className='row'>
      <Section1 className='col-md-12'>
        Terms of use
      </Section1>
    </div>
  </Layout>
}

TermsOfUse.propTypes = {
  pageContext: PropTypes.any
}

export default TermsOfUse
